<template>
  <div class="mb-4">
    <v-container fluid class="secondary">
      <router-link :to="{ name: 'menu' }">
        <img
          class="logo"
          :src="require('@/assets/pharmatLogo.jpg')"
          height="98"
          alt="logo"
        />
      </router-link>
    </v-container>

    <v-container fluid class="primary">
      <v-row>
        <v-col cols="9" md="10">
          <h1 class="ml-16" style="font-size: 2.5em">
            <span id="header">Fo</span>
            <span id="header2">ur</span>
            <span id="header3">nisseurs</span>
          </h1>
        </v-col>
        <v-col v-if="fournisseurLogge">
          <v-row>
            <v-col cols="7" align="right">
              <a :href="lienPdfDocumentation">
                <v-btn x-large icon color="white">
                  <v-icon x-large> mdi-help-circle</v-icon>
                </v-btn>
              </a>
            </v-col>
            <v-col>
              <user-menu></user-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-progress-linear
        v-if="loading"
        class="mt-2"
        height="10"
        indeterminate
        striped
        color="green"
      ></v-progress-linear>
    </v-container>
  </div>
</template>

<script>
import UserMenu from "@/components/UserMenu";
export default {
  name: "AppHeader",
  components: {
    UserMenu,
  },
  computed: {
    fournisseurLogge() {
      return this.$store.state.identite.fournisseur;
    },
    loading() {
      return this.$store.state.loader.loading;
    },
    lienPdfDocumentation() {
      return (
        process.env.VUE_APP_CHEMIN_DOCUMENTS_AIDE + "documentationFrns.pdf"
      );
    },
  },
};
</script>
<style scoped>
.logo {
  position: absolute;
  left: 9%;
  width: 83px;
  bottom: 0;
}

.secondary {
  margin-top: 65px !important;
  display: block;
  position: relative;
  height: 40px;
}

.primary {
  height: 5em;
}

#header {
  color: white;
  border-bottom: 4px solid;
  font-family: "Andes", arial;
  font-weight: 500s;
  padding: 0 0 1px 0;
}
#header2 {
  color: white;
  font-weight: 500;
  font-family: "Andes", arial;
}
#header3 {
  color: white;
  font-weight: 300;
  font-family: "Andes", arial;
}
.guide {
  color: #38af53;
  font-size: 13px;
}

.footer {
  color: white;
  padding: 0 25px;
}
</style>
